import type { JSX, ReactNode } from 'react'

import { Chips } from '@buffer-mono/popcorn'
import type { PostFields } from '@buffer-mono/reminders-config'

import { ChannelFields } from '~publish/components/Composer/components/ChannelFields'

import styles from '~publish/legacy/reminders/components/new-reminders/RemindersWithStickers.module.css'

import { StickerIcon } from './StickerIcon'

export type StickerChipOption = Readonly<{ field: PostFields; label: string }>

export function StickerChipsField({
  stickers,
  value,
  onChange,
  indicator,
}: {
  stickers: readonly StickerChipOption[]
  value: string[]
  onChange: (newValue: string[]) => void
  indicator?: ReactNode
}): JSX.Element {
  return (
    <ChannelFields.Field className={styles.stickersField}>
      <ChannelFields.Label>Add Stickers</ChannelFields.Label>
      <ChannelFields.Control asChild>
        <Chips
          type="multiple"
          className={styles.chips}
          value={value}
          onChange={onChange}
        >
          {stickers.map((sticker) => (
            <Chips.Item key={`chip-${sticker.field}`} value={sticker.field}>
              <StickerIcon field={sticker.field} />
              {sticker.label}
              {indicator}
            </Chips.Item>
          ))}
        </Chips>
      </ChannelFields.Control>
    </ChannelFields.Field>
  )
}
